import {
  Button,
  Col,
  ConfigProvider,
  DatePicker,
  Divider,
  Form,
  Input,
  InputNumber,
  Modal,
  Pagination,
  Radio,
  Row,
  Select,
  Table,
  Tag,
} from 'antd'
import dayjs from 'dayjs'
import React, { useEffect, useState } from 'react'
import { useSearchParams } from 'react-router-dom'
import { useRecoilState } from 'recoil'
import Swal from 'sweetalert2'
import * as XLSX from 'xlsx'
import orderApi from '../../api/order.api'
import programApi from '../../api/program.api'
import promotionApi from '../../api/promotion.api'
import pushApi from '../../api/push.api'
import OrderDetailComponent from '../../components/sales/OrderDetailComponent'
import ContentHeader from '../../components/shared/ContentHeader'
import { searchValueState } from '../../store/searchValue'
import { userState } from '../../store/user'
import { CustomDateButtonRadioTheme } from '../../styles/CustomAntdTheme'
import styles from '../../styles/sales.module.scss'
import statusUtil from '../../utils/status'

const OrderReturnPage = () => {
  const [searchParams] = useSearchParams()
  const [user, setUser] = useRecoilState(userState)
  const [isLoading, setIsLoading] = useState(false)
  const [searchValue, setSearchValue] = useRecoilState(searchValueState)

  const [mediaResult, setMediaResult] = useState(null)
  const [collectionFailHover, setCollectionFailHover] = useState(false)
  const [returnDelayHover, setReturnDelayHover] = useState(false)
  const [refundDelayHover, setRefundDelayHover] = useState(false)
  const [returnRequestHover, setReturnRequestHover] = useState(false)
  const [returnDeliveryHover, setReturnDeliveryHover] = useState(false)
  const [returnDeliveryCompleteHover, setReturnDeliveryCompleteHover] =
    useState(false)
  const [returnCompleteHover, setReturnCompleteHover] = useState(false)
  const [dateType, setDateType] = useState('1week')
  const [searchOptions, setSearchOptions] = useState({
    searchType: 'returnRequestDate',
    searchStatus: 'return_request',
    searchDetailType: '',
    searchDetail: '',
    searchOrderId: '',
    searchProductName: '',
    funnel: 0,
    name: '',
    phone: '',
    startDate: dayjs().subtract(7, 'days').startOf('day'),
    endDate: dayjs().endOf('day'),
  })
  const [orderType, setOrderType] = useState('returnRequestDate')
  const [orderBy, setOrderBy] = useState('desc')
  const [selectedRowKey, setSelectedRowKey] = useState([])
  const [selectedRow, setSelectedRow] = useState([])
  const [currentPageNumber, setCurrentPageNumber] = useState(1)
  const [totalSize, setTotalSize] = useState(0)
  const [offset, setOffset] = useState(0)
  const [pageSize, setPageSize] = useState(10)
  const [deliveryCompanyList, setDeliveryCompanyList] = useState([])
  const [totalOrderList, setTotalOrderList] = useState([])
  const [orderList, setOrderList] = useState([])
  const [orderDetail, setOrderDetail] = useState({})
  const [isOrderModalOpen, setIsOrderModalOpen] = useState(false)

  const [receiveModalOpen, setReceiveModalOpen] = useState(false)
  const [isEditForShipmentPlace, setIsEditForShipmentPlace] = useState(false)
  const [isTrackNumberShow, setIsTrackNumberShow] = useState(false)
  const [trackNumber, setTrackNumber] = useState({
    deliveryCompany: null,
    trackingNumber: '',
    shipmentPlace: '',
    collectionDate:
      dayjs().add(3, 'days').day() === 0
        ? dayjs().add(4, 'days')
        : dayjs().add(3, 'days'),
  })
  // 반품 철회시 거부 사유 입력
  const [returnRefusalModalOpen, setReturnRefusalModalOpen] = useState(false)
  const [refusalReason, setRefusalReason] = useState(null)
  const [costSettingModalOpen, setCostSettingModalOpen] = useState(false)
  const [costInfo, setCostInfo] = useState({
    possibleAmount: 0,
    additionalCost: 0,
    reason: null,
  })
  // 반품완료처리 및 환불안내 팝업
  const [returnCompleteModalOpen, setReturnCompleteModalOpen] = useState(false)
  const [refundInfo, setRefundInfo] = useState({
    calHistory: '',
    total: 0,
  })
  const [showWarningModal, setShowWarningModal] = useState(false)

  // useEffect(() => {
  //   console.log('totalOrderList', selectedRow)
  // }, [selectedRow])

  const searchDateItems = [
    { searchText: '반품요청일', searchType: 'returnRequestDate' },
    { searchText: '수거완료일', searchType: 'returnCollectionCompletedAt' },
    { searchText: '배송완료일', searchType: 'returnDeliveryCompletedAt' },
    { searchText: '결제일', searchType: 'paymentCreatedAt' },
  ]
  const dateTypeItems = [
    { label: '오늘', value: 'today' },
    { label: '1주일', value: '1week' },
    { label: '1개월', value: '1month' },
    { label: '3개월', value: '3month' },
    { label: '6개월', value: '6month' },
  ]
  const orderStatusItems = [
    { label: '전체', value: 'total' },
    { label: '반품요청', value: 'return_request' },
    { label: '반품승인', value: 'return_receive' },
    { label: '반품수거완료', value: 'return_collection_complete' },
    { label: '반품배송중', value: 'return_delivery' },
    { label: '반품배송완료', value: 'return_delivery_complete' },
    { label: '반품완료', value: 'return_complete' },
    { label: '반품수거취소', value: 'return_collection_fail' },
    { label: '반품거부/철회', value: 'return_refusal' },
  ]
  const orderPair = {
    paymentCreatedAt: '결제일순',
    orderId: '주문번호순',
    // ship_date: '발송일순',
    createdAt: '주문일시순',
  }
  const rowSelection = {
    selectedRowKeys: selectedRowKey,
    onChange: (selectedRowKeys, selectedRows) => {
      setSelectedRowKey(selectedRowKeys)
      setSelectedRow(selectedRows)
    },
  }
  const columns = [
    {
      title: '주문번호',
      width: 80,
      dataIndex: 'orderId',
      key: 'orderId',
      fixed: mediaResult ? '' : 'left',
      ellipsis: true,
      align: 'center',
      // sorter: (a, b) => {},
      render: (value, record) => {
        return (
          <span
            className={`${styles['recommend-inquiry-list-title']}`}
            onClick={() => {
              setOrderDetail(record)
              setIsOrderModalOpen(true)
            }}
          >
            {value}
          </span>
        )
      },
    },
    {
      title: '상품주문번호',
      width: 90,
      dataIndex: 'orderDetailId',
      key: 'orderDetailId',
      fixed: mediaResult ? '' : 'left',
      ellipsis: true,
      align: 'center',
    },
    {
      title: '처리상태',
      width: 100,
      dataIndex: 'orderDetailStatus',
      key: 'orderDetailStatus',
      ellipsis: true,
      align: 'center',
      // sorter: (a, b) => {},
      render: (value) => {
        if (value !== null) {
          return statusUtil.orderStatusChange(value)
        }
      },
    },
    {
      title: '반품요청일',
      width: 160,
      dataIndex: 'returnRequestDate',
      key: 'returnRequestDate',
      ellipsis: true,
      align: 'center',
      render: (value) => {
        if (value !== null) {
          const date = dayjs(value).format('YYYY.MM.DD. HH:mm')
          return date
        }
      },
    },
    {
      title: '상품명',
      dataIndex: 'productName',
      key: 'productName',
      ellipsis: true,
      render: (value, record) => {
        return `[${record.brandName}] ${value} ${
          record.optionId ? ' - ' + record.optionTitle : ''
        }`
      },
    },
    {
      title: '반품사유',
      width: 200,
      dataIndex: 'returnReason',
      key: 'returnReason',
      ellipsis: true,
      align: 'center',
      render: (value, record) => {
        if (record.returnReasonDetail) {
          return value + ' - ' + record.returnReasonDetail
        } else {
          return value
        }
      },
    },
    {
      title: '반품승인일',
      width: 160,
      dataIndex: 'returnApprovalDate',
      key: 'returnApprovalDate',
      ellipsis: true,
      align: 'center',
      render: (value) => {
        if (value !== null) {
          const date = dayjs(value).format('YYYY.MM.DD. HH:mm')
          return date
        }
      },
    },
    {
      title: '택배사',
      dataIndex: 'returnDeliveryCompany',
      key: 'returnDeliveryCompany',
      align: 'center',
      render: (value) => {
        if (value === null || value === '') {
          return value
        } else {
          const findDeliveryCompany = deliveryCompanyList.find(
            (deliveryCompany) => deliveryCompany.deliveryCompanyId === value,
          )
          if (findDeliveryCompany) {
            return findDeliveryCompany.deliveryCompanyName
          } else {
            return value
          }
        }
      },
    },
    {
      title: '반송장번호',
      width: 100,
      dataIndex: 'returnTrackingNumber',
      key: 'returnTrackingNumber',
      ellipsis: true,
      align: 'center',
      render: (value, record) => {
        if (value) {
          return (
            <a onClick={(e) => deliveryPopup(e, record)} href={`#`}>
              {value}
            </a>
          )
        }
      },
    },
    {
      title: '반품수거완료일',
      width: 160,
      dataIndex: 'returnCollectionCompleteDate',
      key: 'returnCollectionCompleteDate',
      ellipsis: true,
      align: 'center',
      render: (value) => {
        if (value !== null) {
          const date = dayjs(value).format('YYYY.MM.DD. HH:mm')
          return date
        }
      },
    },
    {
      title: '반품배송완료일',
      width: 160,
      dataIndex: 'returnDeliveryCompleteDate',
      key: 'returnDeliveryCompleteDate',
      ellipsis: true,
      align: 'center',
      render: (value) => {
        if (value !== null) {
          const date = dayjs(value).format('YYYY.MM.DD. HH:mm')
          return date
        }
      },
    },
    {
      title: '반품완료일',
      width: 160,
      dataIndex: 'returnCompleteDate',
      key: 'returnCompleteDate',
      ellipsis: true,
      align: 'center',
      render: (value) => {
        if (value !== null) {
          const date = dayjs(value).format('YYYY.MM.DD. HH:mm')
          return date
        }
      },
    },
    {
      title: '결제일',
      width: 160,
      dataIndex: 'paymentCreatedAt',
      key: 'paymentCreatedAt',
      ellipsis: true,
      align: 'center',
      // sorter: (a, b) => {},
      render: (value) => {
        if (value !== null) {
          const date = dayjs(value).format('YYYY.MM.DD. HH:mm')
          return date
        }
      },
    },
    {
      title: '처방전 상태',
      // width: 90,
      dataIndex: 'prescriptionStatus',
      key: 'prescriptionStatus',
      ellipsis: true,
      render: (status) => {
        // null이나 undefined인 경우 처리
        if (status === null || status === undefined) {
          return (
            <Tag
              color="#6D747A"
              style={{
                color: '#FFF',
                fontWeight: 'bold',
                textAlign: 'center',
                justifyContent: 'center',
                // display: 'flex',
              }}
            >
              -
            </Tag>
          )
        }

        const statusConfig = {
          SUBMITTED: { text: '처방전 제출', color: '#F59E0B' },
          PURCHASED: { text: '구매완료', color: '#117FFA' },
          ADMIN_APPROVED: { text: '관리자 승인', color: '#00A4FF' },
          ADMIN_REJECTED: { text: '관리자 반려', color: '#EB516F' },
          REJECTED: { text: '공단 반려', color: '#EB516F' },
          FINALIZED: { text: '최종 완료', color: '#00A4FF' },
        }

        const config = statusConfig[status] || {
          text: status,
          color: '#6D747A',
        }

        return (
          <Tag
            color={config.color}
            style={{ color: '#FFF', fontWeight: 'bold', textAlign: 'center' }}
          >
            {config.text}
          </Tag>
        )
      },
    },
  ]
  const columnsForRefusal = [
    {
      title: '주문번호',
      width: 80,
      dataIndex: 'orderId',
      key: 'orderId',
      fixed: mediaResult ? '' : 'left',
      // ellipsis: true,
      align: 'center',
    },
    {
      title: '상품주문번호',
      width: 90,
      dataIndex: 'orderDetailId',
      key: 'orderDetailId',
      fixed: mediaResult ? '' : 'left',
      // ellipsis: true,
      align: 'center',
      // sorter: (a, b) => {},
    },
    {
      title: '상품명',
      dataIndex: 'productName',
      key: 'productName',
      ellipsis: true,
      render: (value, record) => {
        return `[${record.brandName}] ${value} ${
          record.optionId ? ' - ' + record.optionTitle : ''
        }`
      },
    },
    {
      title: '상품별 구매가',
      dataIndex: 'totalPrice',
      key: 'totalPrice',
      // ellipsis: true,
      align: 'center',
      render: (value) => {
        if (value) {
          return value.toLocaleString() + '원'
        }
      },
    },
  ]

  /**
   * 쿼리로 상태값 관리하기
   */
  const [propsType, setPropsType] = useState(false)

  useEffect(() => {
    const type = searchParams.get('type')
    if (!propsType && type) {
      setSearchValue({
        ...searchValue,
        searchText: type,
        recordDates: {
          startDate: dayjs().subtract(7, 'days').startOf('day'),
          endDate: dayjs().endOf('day'),
        },
      })
      setPropsType(true)
    }
  }, [searchParams, propsType])

  useEffect(() => {
    if (typeof window !== 'undefined') {
      const matchQueryList = window.matchMedia('all and (max-width: 768px)')
      setMediaResult(matchQueryList.matches)

      const media = function handleChange(e) {
        setMediaResult(e.matches)
      }

      matchQueryList.addEventListener('change', media)
    }
    getDeliveryCompanyList()
    getReturnSummary()
    getUserOrderList('initial')
  }, [])

  useEffect(() => {
    if (searchValue && searchValue.searchText) {
      setDateType('')
      setSearchOptions({
        ...searchOptions,
        startDate: searchValue.recordDates.startDate,
        endDate: searchValue.recordDates.endDate,
        searchStatus:
          searchValue.searchText === 'return_delay'
            ? 'return_delivery_complete'
            : searchValue.searchText === 'return_refund_delay'
              ? 'return_complete'
              : searchValue.searchText,
      })
      getUserOrderList(
        'custom',
        searchValue.recordDates.startDate,
        searchValue.recordDates.endDate,
        searchValue.searchText,
      )
    }
  }, [searchValue])

  useEffect(() => {
    setOrderList(totalOrderList.slice(offset, offset + pageSize))
  }, [offset, pageSize])

  useEffect(() => {
    handleChangePagination(currentPageNumber)
  }, [pageSize])

  useEffect(() => {
    if (searchValue && searchValue.searchText) {
      getUserOrderList(
        'custom',
        searchValue.recordDates.startDate,
        searchValue.recordDates.endDate,
        searchValue.searchText,
      )
    } else {
      getUserOrderList()
    }
  }, [orderType, orderBy])

  const [returnStatus, setReturnStatus] = useState({
    returnRequest: 0,
    returnDelivery: 0,
    returnDeliveryComplete: 0,
    returnComplete: 0,
    returnCollectionFail: 0,
    returnDelay: 0,
    returnRefundDelay: 0,
  })

  /**
   * 반품관리 상태값 개수 가져오기
   * @returns {Promise<void>}
   */
  const getReturnSummary = async () => {
    const res = await orderApi.salesManageStatus(null, user.id)
    if (res.data.code === 200) {
      setReturnStatus({
        returnRequest: res.data.result.returnRequestList,
        returnDelivery: res.data.result.returnDeliveryList,
        returnDeliveryComplete: res.data.result.returnDeliveryCompleteList,
        returnComplete: res.data.result.returnCompleteList,
        returnCollectionFail: res.data.result.returnCollectionFailList,
        returnDelay: res.data.result.returnDelayList,
        returnRefundDelay: res.data.result.returnRefundDelayList,
      })
    }
  }

  const getDeliveryCompanyList = async () => {
    setIsLoading(true)
    try {
      const res = await orderApi.deliveryCompanyList(user.id)
      if (res.data.code === 200) {
        setDeliveryCompanyList(res.data.result)
      } else {
        alert(
          '해당 정보를 가져오는데 실패했습니다. 다시 시도해주시기 바랍니다.',
        )
      }
      setIsLoading(false)
    } catch (error) {
      setIsLoading(false)
      console.log('getDeliveryCompanyList read error', error)
    }
  }

  const getUserOrderList = async (
    type = '',
    startDate,
    endDate,
    searchStatus,
  ) => {
    setIsLoading(true)
    try {
      let param
      if (type === 'initial') {
        param = {
          offset: 0,
          pageSize: 10,
          pageType: 'return',
          searchType: searchDateItems[0].searchType,
          startDate: dayjs()
            .subtract(7, 'days')
            .startOf('day')
            .format('YYYY-MM-DD HH:mm:ss'),
          endDate: dayjs().endOf('day').format('YYYY-MM-DD HH:mm:ss'),
          searchStatus: orderStatusItems[1].value,
          searchOrderId: null,
          searchProductName: '',
          funnel: 0,
          name: '',
          phone: '',
          orderType: 'paymentCreatedAt',
          orderBy: 'desc',
          searchDetailType: '',
          searchDetail: '',
          settlementId: null,
        }
      } else if (type === 'search') {
        param = {
          offset: 0,
          pageSize: 10,
          pageType: 'return',
          searchType: searchOptions.searchType,
          startDate: dayjs(searchOptions.startDate)
            .startOf('day')
            .format('YYYY-MM-DD HH:mm:ss'),
          endDate: dayjs(searchOptions.endDate)
            .endOf('day')
            .format('YYYY-MM-DD HH:mm:ss'),
          searchStatus: searchOptions.searchStatus,
          searchOrderId: searchOptions.searchOrderId,
          searchProductName: searchOptions.searchProductName,
          funnel: searchOptions.funnel,
          name: searchOptions.name,
          phone: searchOptions.phone.includes('-')
            ? searchOptions.phone.replaceAll('-', '')
            : searchOptions.phone,
          orderType: orderType,
          orderBy: orderType,
          searchDetailType: '',
          searchDetail: '',
          settlementId: null,
        }
      } else if (type === 'custom') {
        param = {
          offset: offset,
          pageSize: pageSize,
          pageType: 'return',
          searchType: searchOptions.searchType,
          startDate: dayjs(searchOptions.startDate)
            .startOf('day')
            .format('YYYY-MM-DD HH:mm:ss'),
          endDate: dayjs(searchOptions.endDate)
            .endOf('day')
            .format('YYYY-MM-DD HH:mm:ss'),
          searchStatus: searchStatus,
          searchOrderId: searchOptions.searchOrderId,
          searchProductName: searchOptions.searchProductName,
          funnel: searchOptions.funnel,
          name: searchOptions.name,
          phone: searchOptions.phone.includes('-')
            ? searchOptions.phone.replaceAll('-', '')
            : searchOptions.phone,
          orderType: orderType,
          orderBy: orderType,
          searchDetailType: '',
          searchDetail: '',
          settlementId: null,
        }
      } else {
        param = {
          offset: offset,
          pageSize: pageSize,
          pageType: 'return',
          searchType: searchOptions.searchType,
          startDate: dayjs(searchOptions.startDate)
            .startOf('day')
            .format('YYYY-MM-DD HH:mm:ss'),
          endDate: dayjs(searchOptions.endDate)
            .endOf('day')
            .format('YYYY-MM-DD HH:mm:ss'),
          searchStatus: searchOptions.searchStatus,
          searchOrderId: searchOptions.searchOrderId,
          searchProductName: searchOptions.searchProductName,
          funnel: searchOptions.funnel,
          name: searchOptions.name,
          phone: searchOptions.phone.includes('-')
            ? searchOptions.phone.replaceAll('-', '')
            : searchOptions.phone,
          orderType: orderType,
          orderBy: orderType,
          searchDetailType: '',
          searchDetail: '',
          settlementId: null,
        }
      }
      const res = await orderApi.searchOrderDetailList(param, user.id)
      if (res.data.code === 200) {
        // setTotalOrderList(res.data.result.userOrderDetailDTOList)
        setTotalOrderList([...res.data.result.userOrderDetailDTOList].reverse())
        if (type === 'initial' || type === 'search') {
          setOrderList(res.data.result.userOrderDetailDTOList.slice(0, 10))
        } else {
          setOrderList(
            res.data.result.userOrderDetailDTOList.slice(
              offset,
              offset + pageSize,
            ),
          )
        }
        if (res.data.result?.length !== 0) {
          setTotalSize(res.data.result.totalCnt)
        } else {
          setTotalSize(0)
        }
      } else {
        alert(
          '해당 정보를 가져오는데 실패했습니다. 다시 시도해주시기 바랍니다.',
        )
      }
      setIsLoading(false)
    } catch (error) {
      setIsLoading(false)
      console.log('getUserOrderList read error', error)
    }
  }

  /**
   * 선택한 주문의 반품 관련 주문 목록 정보 조회 (2023.07.21) - ksb
   * 1. 선택한 주문이외의 반품 관련 주문 목록들의 기타 반품비용 합계
   */
  const getOrderDetailListInfoForReturn = async () => {
    setIsLoading(true)
    try {
      const param = {
        orderId: selectedRow[0].orderId,
        orderDetailId: selectedRow[0].orderDetailId,
      }
      const res = await orderApi.getEtcReturnPriceSum(param, user.id)
      if (res.data.code === 200) {
        let availablePrice =
          selectedRow[0].paymentTotalPrice - res.data.result.etcReturnPrice
        // 반품배송비 환불금에서 차감이면 해당 금액만큼 제외
        if (
          selectedRow[0].returnResponsibility === 'USER' &&
          !selectedRow[0].purchaseReturnPrice
        ) {
          availablePrice -=
            selectedRow[0].returnDeliveryPrice -
            selectedRow[0].paidTotalDeliveryPrice
        }
        setCostInfo({ ...costInfo, possibleAmount: availablePrice })
        setIsLoading(false)
      } else if (res.data.code === 999) {
        throw res.data.msg
      } else {
        throw '반품가능한 비용을 계산하기 위해 조회하는 부분에서 오류가 발생했습니다. 다시 시도해주시거나 똑같은 오류가 계속해서 발생한다면 관리자에게 문의해주시길 바랍니다.'
      }
    } catch (e) {
      setCostInfo({ ...costInfo, possibleAmount: null })
      setIsLoading(false)
      console.log('getOrderDetailListInfoForReturn read error', e)
    }
  }

  const changeOrderStatus = async (orderStatus) => {
    setIsLoading(true)
    try {
      const orderIdSet = new Set(
        selectedRow.map((selectedRow) => selectedRow.orderId),
      )
      const editOrderList = {
        orderIdList: [...orderIdSet],
        orderDetailIdList: selectedRowKey,
        orderStatus: orderStatus,
      }
      if (orderStatus === 'return_refusal') {
        console.log('return_refusal:: refusalReason', refusalReason)
        editOrderList['returnRefusalReason'] = refusalReason.trim()
      } else if (orderStatus === 'return_receive') {
        if (isEditForShipmentPlace) {
          const orderDetailList = selectedRow.map((row) => {
            return { ...row, shipmentPlace: trackNumber.shipmentPlace }
          })
          editOrderList['shipmentPlace'] = trackNumber.shipmentPlace
          editOrderList['orderDetailWithProductList'] = orderDetailList
        } else {
          editOrderList['orderDetailWithProductList'] = selectedRow
        }
        editOrderList['returnCollectionExpectedDate'] = dayjs(
          trackNumber.collectionDate,
        ).format('YYYY-MM-DD HH:mm:ss')
        editOrderList['returnDeliveryCompany'] = trackNumber.deliveryCompany
      }
      const res = await orderApi.orderStatusEdit(editOrderList, user.id)
      console.log('orderStatusEdit res', res)
      if (res.data.code === 200 || res.code === 200) {
        if (orderStatus === 'return_refusal') {
          const kakaoFilterdList = orderList
            .filter((order) =>
              editOrderList.orderDetailIdList.includes(order.orderDetailId),
            )
            .map((order) => {
              return {
                ...order,
                returnRefusalReason: refusalReason.trim(), // null 상태 업데이트하여 보내기
              }
            })
          const kakaoRes = await sendKakaoRefusalAlert(
            kakaoFilterdList,
            user.id,
          )
          if (kakaoRes.data.code === 200) {
            alert(
              `총 ${selectedRow?.length}건의 반품거부 처리가 완료되었습니다.`,
            )
            handleReturnRefusalModalCancel()
          } else if (kakaoRes.data.code !== 200) {
            alert(
              '반품 거부 알림톡을 전달하는데 실패했습니다. \n관리자에게 문의하시길 바랍니다.',
            )
            handleReceiveModalCancel()
          }
        } else if (orderStatus === 'return_receive') {
          // 반품 승인
          const kakaoFilterdList = orderList.filter((order) =>
            editOrderList.orderDetailIdList.includes(order.orderDetailId),
          )
          const kakaoRes = await pushApi.kakaoForRefundRequestConfirm(
            kakaoFilterdList,
            user.id,
          )
          // console.log('kakaoFilterdList', kakaoFilterdList)
          if (kakaoRes.data.code === 200) {
            alert(
              `총 ${selectedRow?.length}건의 반품승인 처리가 완료되었습니다.`,
            )
            handleReceiveModalCancel()
          } else if (kakaoRes.data.code !== 200) {
            alert(
              '반품 승인 알림톡을 전달하는데 실패했습니다. \n관리자에게 문의하시길 바랍니다.',
            )
            handleReceiveModalCancel()
          }
        } else if (orderStatus === 'return_complete') {
          alert(`총 ${selectedRow?.length}건의 반품완료 처리가 완료되었습니다.`)
          if (returnCompleteModalOpen) {
            handleReturnCompleteModalCancel()
          }
        } else {
          alert('해당 내용이 성공적으로 반영되었습니다.')
        }
        setSelectedRowKey([])
        setSelectedRow([])
        getUserOrderList()
        getReturnSummary()
      } else if (res.data.code === 999 || res.data.code === 405) {
        alert(res.data.msg)
        setIsLoading(false)
      } else {
        alert(
          '해당 내용을 수정하는데 실패했습니다. 관리자에게 문의하시길 바랍니다.',
        )
        setIsLoading(false)
      }
    } catch (error) {
      setIsLoading(false)
      console.log('changeOrderStatus edit error', error)
    }
  }

  /**
   * 반품 완료처리 버튼 클릭
   */
  const handleReturnCompleteClick = async () => {
    setIsLoading(true)
    try {
      // 1. 선택한 주문번호에 대한 detail목록 조회
      const param = {
        orderId: selectedRow[0].orderId,
        userIdByOrder: selectedRow[0].createdBy,
        exceptedOrderDetailIdList: selectedRowKey.join(','),
      }
      const res = await orderApi.searchOrderOne(param, user.id)
      if (res.data.code === 200) {
        setIsLoading(false)
        if (
          res.data.result.orderDetailDTOList?.length === 0 ||
          res.data.result.orderDetailDTOList.every(
            (orderDetail) =>
              orderDetail.orderDetailStatus === 'return_complete',
          )
        ) {
          // 2-1. 전체 반품 완료 및 환불처리 진행 -> 환불 안내 팝업 열기
          let sum = selectedRow[0].paymentTotalPrice
          let sumStr = `${selectedRow[0].paymentTotalPrice.toLocaleString()}원`
          if (
            selectedRow[0].returnResponsibility === 'USER' &&
            !selectedRow[0].purchaseReturnPrice
          ) {
            sum -=
              selectedRow[0].returnDeliveryPrice -
              selectedRow[0].paidTotalDeliveryPrice
            sumStr += ` - ${(
              selectedRow[0].returnDeliveryPrice -
              selectedRow[0].paidTotalDeliveryPrice
            ).toLocaleString()}원`
          }
          for (let i = 0; i < selectedRow?.length; i++) {
            const row = selectedRow[i]
            if (row.etcReturnPrice) {
              sum -= selectedRow[0].etcReturnPrice
              sumStr += ` - ${selectedRow[0].etcReturnPrice.toLocaleString()}원`
            }
          }
          sumStr += ` = ${sum.toLocaleString()}원`
          if (sumStr.split(' = ')[0] === sumStr.split(' = ')[1]) {
            sumStr = ''
          }
          setRefundInfo({
            calHistory: sumStr,
            total: sum,
          })
          setReturnCompleteModalOpen(true)
        } else {
          // 2-2. 반품 완료 처리
          if (
            window.confirm(
              `총 ${selectedRow?.length}건 반품 완료 처리 진행하시겠습니까?\n\n* 같은 주문번호 내 반품완료처리되지 않은 건이 존재합니다. 해당건까지 반품 완료되어야만 환불처리가 진행됩니다.`,
            )
          ) {
            changeOrderStatus('return_complete')
          }
        }
      } else {
        throw '서버오류가 발생했습니다. 새로고침 후 다시 시도해주시길 바랍니다.'
      }
    } catch (e) {
      setIsLoading(false)
      alert(e)
    }
  }

  /**
   * 반품 송장 저장
   */
  const handleTrackNumber = async () => {
    try {
      if (trackNumber.trackingNumber?.trim() && trackNumber.deliveryCompany) {
        setIsLoading(true)
        let hasTrackingNum = false
        const findCompanyIdx = deliveryCompanyList.findIndex(
          (delivery) =>
            delivery.deliveryCompanyId === trackNumber.deliveryCompany,
        )
        if (findCompanyIdx === -1) {
          throw '데이터를 저장하는 부분에서 오류가 발생했습니다. 다시 시도해주세요.\n만약 동일한 오류가 계속해서 발생한다면, 관리자에게 문의해주시길 바랍니다.'
        }
        for (let i = 0; i < selectedRow?.length; i++) {
          const row = selectedRow[i]
          if (row.returnTrackingNumber) {
            hasTrackingNum = true
            break
          }
        }
        let alertStr = `총 ${selectedRow?.length}건에 ${deliveryCompanyList[findCompanyIdx].deliveryCompanyName} - ${trackNumber.trackingNumber}를 등록하시겠습니까?`
        if (hasTrackingNum) {
          alertStr =
            `선택된 주문들 중 이미 반품 송장번호가 등록된 주문건이 존재합니다. 해당 주문건 포함해서 ` +
            alertStr
        }
        if (window.confirm(alertStr)) {
          let paramDetailList = []
          for (let i = 0; i < selectedRow?.length; i++) {
            const row = selectedRow[i]
            const orderDetailItem = {
              orderId: row.orderId,
              orderDetailId: row.orderDetailId,
              brandId: row.brandId,
              brandName: row.brandName,
              productId: row.productId,
              productName: row.productName,
              optionId: row.optionId ?? null,
              optionTitle: row.optionTitle,
              orderDetailStatus: row.orderDetailStatus,
              deliveryCompany: trackNumber.deliveryCompany,
              trackingNumber: trackNumber.trackingNumber,
              createdBy: row.createdBy,
            }
            paramDetailList.push(orderDetailItem)
          }
          const param = {
            userOrderDetailDTOList: paramDetailList,
          }
          const res = await orderApi.postReturnTrackingNumber(param, user.id)
          if (res.data.code === 200) {
            alert('작성하신 반품 송장 정보를 성공적으로 등록하였습니다.')
            handleRegisterTrackingModalCancel()
            setSelectedRow([])
            setSelectedRowKey([])
            getUserOrderList()
          } else {
            handleRegisterTrackingModalCancel()
            setSelectedRow([])
            setSelectedRowKey([])
            getUserOrderList()
            throw res.data.msg.replaceAll('return_', '')
          }
        }
        setIsLoading(false)
      } else {
        throw '택배사 또는 송장번호를 올바르게 입력해주세요.'
      }
    } catch (e) {
      setIsLoading(false)
      alert(e)
    }
  }

  /**
   * 반품 승인처리 팝업 내 확인 버튼 클릭
   */
  const returnReceive = async () => {
    if (trackNumber.collectionDate && trackNumber.deliveryCompany) {
      setIsLoading(true)
      const findCompanyIdx = deliveryCompanyList.findIndex(
        (delivery) =>
          delivery.deliveryCompanyId === trackNumber.deliveryCompany,
      )
      if (findCompanyIdx === -1) {
        alert(
          '데이터를 저장하는 부분에서 오류가 발생했습니다. 다시 시도해주세요.\n만약 동일한 오류가 계속해서 발생한다면, 관리자에게 문의해주시길 바랍니다.',
        )
        setIsLoading(false)
      } else {
        // 무통장 입금건 계좌 정보 확인
        const vbankOrders = selectedRow.filter(
          (row) => row.payMethod === 'vbank',
        )

        if (vbankOrders.length > 0) {
          const missingAccountInfo = vbankOrders.filter(
            (row) =>
              !row.refundBank ||
              !row.refundHolder ||
              !row.refundAccount ||
              row.refundBank === '' ||
              row.refundHolder === '' ||
              row.refundAccount === '',
          )

          if (missingAccountInfo.length > 0) {
            alert(
              '[주의] 무통장 입금건 취소 계좌 정보 버튼을 눌러 확인 후 개발팀에 알려주세요.\n\n' +
                '무통장 결제건 중 환불 계좌 정보가 누락된 주문이 있습니다.\n' +
                '주문번호: ' +
                missingAccountInfo.map((row) => row.orderId).join(', '),
            )
            setIsLoading(false)
            return
          }
        }

        if (
          window.confirm(
            `수거 택배사: ${
              deliveryCompanyList[findCompanyIdx].deliveryCompanyName
            }\n수거 예정일: ${trackNumber.collectionDate.format(
              'YYYY-MM-DD',
            )}\n수거지: ${
              isEditForShipmentPlace
                ? trackNumber.shipmentPlace
                : '각 상품별 반품/교환 회수지'
            }\n위의 정보로 고객분께 안내될 예정입니다. 총 ${
              selectedRow?.length
            }건 반품 승인 처리 진행하시겠습니까?`,
          )
        ) {
          changeOrderStatus('return_receive')
          // 선택된 모든 주문에 대해 프로그램 티켓 상태 변경
          const uniqueOrderIds = [
            ...new Set(selectedRow.map((row) => row.orderId)),
          ]
          for (const orderId of uniqueOrderIds) {
            await unavailableProgram(orderId)
          }
        } else {
          setIsLoading(false)
        }
      }
    } else {
      alert('택배사 또는 송장번호를 올바르게 입력해주세요.')
    }
  }

  /**
   * 반품 거부(철회) 처리 팝업 내 확인 버튼 클릭
   */
  const returnRefusal = async () => {
    if (
      window.confirm(
        `거부 사유: ${refusalReason}\n총 ${selectedRow?.length}건 반품 거부 처리 진행하시겠습니까?`,
      )
    ) {
      await changeOrderStatus('return_refusal')
    }
  }

  /**
   * 반품비용 설정 팝업 내 저장 버튼 클릭
   */
  const registerEtcReturnPrice = async () => {
    if (
      window.confirm(
        `"${
          costInfo.reason
        }"로 반품 비용 ${costInfo.additionalCost.toLocaleString()}원 청구 진행하시겠습니까?`,
      )
    ) {
      setIsLoading(true)
      try {
        const param = {
          ...selectedRow[0],
          etcReturnPrice: costInfo.additionalCost,
          etcReturnPriceReason: costInfo.reason.trim(),
        }
        const res = await orderApi.postEtcReturnPrice(param, user.id)
        // console.log('registerEtcReturnPrice', res)
        if (res.data.code === 200) {
          alert(
            '선택하신 주문에 입력된 추가 반품비용 정보가 정상적으로 등록되었습니다.',
          )
          setIsLoading(false)
          handleReturnCostSettingModalCancel()
          setSelectedRow([])
          setSelectedRowKey([])
          getUserOrderList()
        } else if (res.data.code === 406 || res.data.code === 999) {
          throw res.data.msg
        } else {
          throw '입력하신 반품비용을 저장하는 부분에서 오류가 발생했습니다. 새로고침 후 다시 시도해주시거나 동일한 오류가 계속 발생된다면 관리자에게 문의해주시길 바랍니다.'
        }
      } catch (e) {
        setIsLoading(false)
        console.log('registerEtcReturnPrice edit error', e)
        alert(e)
      }
    }
  }

  /**
   * 환불 안내 팝업 내 확인 버튼 클릭
   */
  const registerReturnComplete = async () => {
    if (
      window.confirm(
        `안내된 정보로 반품완료 및 총 ${refundInfo.total.toLocaleString()}원 환불처리 진행하시겠습니까?`,
      )
    ) {
      handleReturnComplete()
    }
  }

  /**
   * PortOne 환불 처리 + 포인트 환불 + 쿠폰 환불
   */
  const handleReturnComplete = async () => {
    setIsLoading(true)
    try {
      const selectOrder = selectedRow[0]
      const param = {
        userId: selectOrder.createdBy,
        orderId: selectOrder.orderId,
      }
      // 1. 해당 주문건 실제 결제 정보 조회
      const res = await orderApi.getPaymentSearch(param, user.id)
      if (res.data.code === 200) {
        let cancelParam = {
          ...res.data.result,
          userOrderDetailList: [...selectedRow],
          merchantUid: selectOrder.orderId,
          reason: `[반품-${selectOrder?.returnReason}]${
            selectOrder.returnReasonDetail ?? ''
          }`,
          cancelRequestAmount: refundInfo.total,
        }
        // 1-1. 가상계좌 결제시, 환불받을 계좌 정보 여부 확인
        if (cancelParam.payMethod === 'vbank') {
          if (
            !!selectOrder.refundBank &&
            !!selectOrder.refundHolder &&
            !!selectOrder.refundAccount
          ) {
            cancelParam = {
              ...cancelParam,
              refundHolder: selectOrder.refundHolder ?? null,
              refundBank: selectOrder.refundBank ?? null,
              refundAccount: selectOrder.refundAccount ?? null,
            }
          } else {
            throw '환급 받을 계좌 정보가 없습니다.'
          }
        }
        const pointParam = {
          totalOrder: {
            id: selectOrder.orderId,
            orderStatus: 'return_complete',
          },
        }
        let couponList = []
        for (let i = 0; i < selectedRow?.length; i++) {
          if (selectedRow[i].couponId) {
            couponList.push(selectedRow[i].couponId)
          }
        }
        const couponParam = {
          couponIdList: couponList?.length ? couponList : [],
          userCouponIsAvailable: true,
          userId: selectedRow[0].createdBy,
        }
        // 2. 포트원 환불
        // console.log('cancelParam', cancelParam)
        const rsq = await orderApi.postReturnPortOne(cancelParam, user.id)
        if (rsq.data.code === 203) {
          // 2-1. 정상 환불됨 -> 포인트/쿠폰 환급
          const pointRes = await orderApi.purchasePointCancel(
            pointParam,
            user.id,
          )
          if (pointRes.data.code !== 200) {
            throw `해당 주문건에서 사용한 포인트를 환급하는 과정에서 오류가 발생했습니다.\n관리자에게 문의하시길 바랍니다.`
          }
          const couponRes = await promotionApi.userCouponChangeStatus(
            couponParam,
            user.id,
          )
          if (couponRes.data.code !== 200) {
            throw `해당 주문건에 대한 쿠폰 정보를 수정하는 부분에서 오류가 발생했습니다.\n관리자에게 문의하시길 바랍니다.`
          }
          setIsLoading(false)
          alert('정상적으로 환불이 완료되었습니다.')
          handleReturnCompleteModalCancel()
          setSelectedRowKey([])
          setSelectedRow([])
          getUserOrderList()
          getReturnSummary()
        } else if (rsq.data.code === 420) {
          // 2-2. 이미 환불 완료됨 -> 상태값 변경 및 포인트/쿠폰 환급
          alert('이미 환불 완료된 주문입니다. 쿠폰 및 포인트 환급 진행합니다.')
          const pointRes = await orderApi.purchasePointCancel(
            pointParam,
            user.id,
          )
          if (pointRes.data.code !== 200) {
            throw `해당 주문건에서 사용한 포인트를 환급하는 과정에서 오류가 발생했습니다.\n관리자에게 문의하시길 바랍니다.`
          }
          const couponRes = await promotionApi.userCouponChangeStatus(
            couponParam,
            user.id,
          )
          if (couponRes.data.code !== 200) {
            throw `해당 주문건에 대한 쿠폰 정보를 수정하는 부분에서 오류가 발생했습니다.\n관리자에게 문의하시길 바랍니다.`
          }
          changeOrderStatus('return_complete')
        } else {
          throw '오류가 발생했습니다. 관리자에게 문의하세요.'
        }
      } else {
        throw '서버오류가 발생했습니다. 새로고침 후 다시 시도해주시길 바랍니다.'
      }
    } catch (e) {
      setIsLoading(false)
      console.log('handleReturnComplete === ', e)
      alert(e)
      handleReturnCompleteModalCancel()
    }
  }

  /**
   * excel download
   */
  const handleExcelDownloadClick = () => {
    try {
      let excelData
      if (selectedRow?.length !== 0) {
        excelData = selectedRow.map((row) => {
          return {
            orderId: `SG${row.orderId}`,
            orderDetailId: `sg${row.orderDetailId}`,
            paymentCreatedAt: dayjs(row.paymentCreatedAt).format(
              'YYYY.MM.DD HH:mm',
            ),
            orderDetailStatus:
              statusUtil.matchingOrderStatus[row.orderDetailStatus],
            // productId: row.productId,
            productId: `SUG-${row.productId}`,
            productName: row.productName,
            // optionId: row.optionId,
            optionId: `sgot-${row.optionId}`,
            optionTitle: row.optionTitle,
            quantity: row.quantity,
            totalPrice: row.totalPrice,
            price: row.price,
            couponDiscountPrice: row.couponDiscountPrice,
            createdByName: row.createdByName,
            usePoint: row.usePoint ? 'Y' : 'N',
            name: row.name,
            phone: row.phone,
            address: row.address
              ? row.address +
                (row.addressDetail ? `, ${row.addressDetail}` : '')
              : '',
            addressRequest:
              row.addressRequest === '배송 시 요청사항을 선택해주세요.'
                ? ''
                : row.addressRequest,
            deliveryCompany: statusUtil.matchingDeliveryCompany[
              row.deliveryCompany
            ]
              ? statusUtil.matchingDeliveryCompany[row.deliveryCompany]
              : row.deliveryCompany,
            trackingNumber: row.trackingNumber,
            shipDate: row.shipDate
              ? dayjs(row.shipDate).format('YYYY.MM.DD')
              : row.shipDate,
          }
        })
      } else if (totalOrderList?.length !== 0) {
        excelData = totalOrderList.map((row) => {
          return {
            orderId: `SG${row.orderId}`,
            orderDetailId: `sg${row.orderDetailId}`,
            paymentCreatedAt: dayjs(row.paymentCreatedAt).format(
              'YYYY.MM.DD HH:mm',
            ),
            orderDetailStatus:
              statusUtil.matchingOrderStatus[row.orderDetailStatus],
            // productId: row.productId,
            productId: `SUG-${row.productId}`,
            productName: row.productName,
            // optionId: row.optionId,
            optionId: `sgot-${row.optionId}`,
            optionTitle: row.optionTitle,
            quantity: row.quantity,
            totalPrice: row.totalPrice,
            price: row.price,
            couponDiscountPrice: row.couponDiscountPrice,
            createdByName: row.createdByName,
            usePoint: row.usePoint ? 'Y' : 'N',
            name: row.name,
            phone: row.phone,
            address: row.address
              ? row.address +
                (row.addressDetail ? `, ${row.addressDetail}` : '')
              : '',
            addressRequest:
              row.addressRequest === '배송 시 요청사항을 선택해주세요.'
                ? ''
                : row.addressRequest,
            deliveryCompany: statusUtil.matchingDeliveryCompany[
              row.deliveryCompany
            ]
              ? statusUtil.matchingDeliveryCompany[row.deliveryCompany]
              : row.deliveryCompany,
            trackingNumber: row.trackingNumber,
            shipDate: row.shipDate
              ? dayjs(row.shipDate).format('YYYY.MM.DD')
              : row.shipDate,
          }
        })
      } else {
        alert(
          '다운받으려는 데이터가 없습니다. 조회 후 다시 시도해주시길 바랍니다.',
        )
        throw 'no data'
      }
      const wb = XLSX.utils.book_new()
      const ws = XLSX.utils.json_to_sheet(excelData)
      Object.keys(excelData[0]).forEach((key, idx) => {
        const cellAdd = XLSX.utils.encode_cell({ c: idx, r: 0 })
        ws[cellAdd].v = statusUtil.matchingKey[key]
      })
      XLSX.utils.book_append_sheet(wb, ws, '주문조회')
      XLSX.writeFile(wb, `${dayjs().format('YYYYMMDD')}_주문조회.xlsx`)
    } catch (error) {
      setIsLoading(false)
      console.log('handleExcelDownloadClick edit error', error)
    }
  }

  /**
   * 상단 반품관련 상태값 click handler
   */
  const handleReturnStatusItemClick = (returnStatus, list) => {
    let saveParam = {
      searchText: returnStatus,
    }
    if (list && list?.length > 0) {
      saveParam = {
        ...saveParam,
        recordDates: {
          startDate: dayjs(list[list?.length - 1].updatedAt).startOf('day'),
          endDate: dayjs(list[0].updatedAt).endOf('day'),
        },
      }
    } else {
      saveParam = {
        ...saveParam,
        recordDates: {
          startDate: dayjs().subtract(7, 'days').startOf('day'),
          endDate: dayjs().endOf('day'),
        },
      }
    }
    setSearchValue({
      ...searchValue,
      ...saveParam,
    })
  }
  /**
   * handle dateType change
   */
  const handleDateTypeChange = (e) => {
    const value = e.target.value
    setDateType(value)
    switch (value) {
      case 'today':
        setSearchOptions({
          ...searchOptions,
          startDate: dayjs().startOf('day'),
          endDate: dayjs().endOf('day'),
        })
        break
      case '1week':
        if (searchOptions.endDate === null || searchOptions.endDate === '') {
          setSearchOptions({
            ...searchOptions,
            startDate: dayjs().subtract(7, 'days').startOf('day'),
            endDate: dayjs().endOf('day'),
          })
        } else {
          setSearchOptions({
            ...searchOptions,
            startDate: dayjs(searchOptions.endDate.format('YYYY/MM/DD'))
              .subtract(7, 'days')
              .startOf('day'),
          })
        }
        break
      case '1month':
        if (searchOptions.endDate === null || searchOptions.endDate === '') {
          setSearchOptions({
            ...searchOptions,
            startDate: dayjs().subtract(1, 'months').startOf('day'),
            endDate: dayjs().endOf('day'),
          })
        } else {
          setSearchOptions({
            ...searchOptions,
            startDate: dayjs(searchOptions.endDate.format('YYYY/MM/DD'))
              .subtract(1, 'months')
              .startOf('day'),
          })
        }
        break
      case '3month':
        if (searchOptions.endDate === null || searchOptions.endDate === '') {
          setSearchOptions({
            ...searchOptions,
            startDate: dayjs().subtract(3, 'months').startOf('day'),
            endDate: dayjs().endOf('day'),
          })
        } else {
          setSearchOptions({
            ...searchOptions,
            startDate: dayjs(searchOptions.endDate.format('YYYY/MM/DD'))
              .subtract(3, 'months')
              .startOf('day'),
          })
        }
        break
      case '6month':
        if (searchOptions.endDate === null || searchOptions.endDate === '') {
          setSearchOptions({
            ...searchOptions,
            startDate: dayjs().subtract(6, 'months').startOf('day'),
            endDate: dayjs().endOf('day'),
          })
        } else {
          setSearchOptions({
            ...searchOptions,
            startDate: dayjs(searchOptions.endDate.format('YYYY/MM/DD'))
              .subtract(6, 'months')
              .startOf('day'),
          })
        }
        break
    }
  }

  /**
   * 검색
   * + redux에 저장된 값 지우기
   */
  const handleSearch = () => {
    if (
      dayjs(searchOptions.startDate) === null ||
      dayjs(searchOptions.endDate) === null
    ) {
      alert('조회하려는 기간이 없습니다. 다시 설정해주시길 바랍니다.')
    } else {
      if (!dayjs(searchOptions.startDate).isBefore(searchOptions.endDate)) {
        alert(
          '조회하려는 기간이 잘못 설정되어있습니다. 다시 시도해주시길 바랍니다.',
        )
      } else {
        setOffset(0)
        setCurrentPageNumber(1)
        setSelectedRowKey([])
        setSelectedRow([])
        setSearchValue({
          ...searchValue,
          searchText: '',
          recordDates: {
            startDate: dayjs().format('YYYY-MM-DD'),
            endDate: dayjs().add(1, 'd').format('YYYY-MM-DD'),
          },
        })
        getUserOrderList('search')
      }
    }
  }

  /**
   * 초기화
   * + redux에 저장된 값 지우기
   */
  const handleInitialBtnClick = () => {
    setSearchOptions({
      searchType: searchDateItems[0].searchType,
      searchStatus: orderStatusItems[1].value,
      searchOrderId: '',
      searchProductName: '',
      funnel: 0,
      name: '',
      phone: '',
      startDate: dayjs().subtract(7, 'days').startOf('day'),
      endDate: dayjs().endOf('day'),
    })
    setDateType(dateTypeItems[1].value)
    setOffset(0)
    setPageSize(10)
    setSelectedRowKey([])
    setSelectedRow([])
    setSearchValue({
      ...searchValue,
      searchText: '',
      recordDates: {
        startDate: dayjs().format('YYYY-MM-DD'),
        endDate: dayjs().add(1, 'd').format('YYYY-MM-DD'),
      },
    })
    getUserOrderList('initial')
  }

  const tableOnChange = (pagination, filters, sorter) => {
    if (sorter) {
      //sorting 이벤트가 이루어졌을때
      if (sorter.order) {
        if (sorter.order === 'descend') {
          setOrderBy('desc')
        } else if (sorter.order === 'ascend') {
          setOrderBy('asc')
        }
        setOrderType(sorter.field)
        //sorting 이벤트 데이터가 초기화 되었을 시 (order 값 초기화)
      } else {
        setOrderType('returnRequestDate')
        setOrderBy('desc')
      }
    }
  }

  /**
   * page 넘김
   */
  const handleChangePagination = (pageNumber) => {
    const currOffset = (pageNumber - 1) * pageSize
    setCurrentPageNumber(pageNumber)
    setOffset(currOffset)
  }

  /**
   * pageSize 변경 handler
   */
  const pageSizeChange = (current, pageSize) => {
    setPageSize(pageSize)
    setOffset((current - 1) * pageSize)
  }

  /**
   * 송장번호에 따른 배송안내 popup
   * @param detail
   */
  const deliveryPopup = (e, detail) => {
    e.preventDefault()
    e.stopPropagation()
    let popUrl = `https://www.goodsflow.io/tracking/tXYtiyVnAX/${detail.returnGoodsflowServiceId}`
    let popOption =
      'top=10, left=10, width=500, height=700, scrollbars=yes, resizable=no'
    window.open(popUrl, '배송조회', popOption)
  }

  /**
   * 주문 상세 Modal cancel handler
   */
  const handleOrderDetailModalCancel = () => {
    setIsOrderModalOpen(false)
    setOrderDetail({})
  }

  /**
   * 반품 승인처리 Modal click handler
   */
  const handleReceiveModalClick = () => {
    setReceiveModalOpen(true)
    for (let i = 0; i < selectedRow?.length; i++) {
      const row = selectedRow[i]
      if (row.shipmentPlace) {
        setTrackNumber({
          ...trackNumber,
          shipmentPlace: row.shipmentPlace,
        })
        break
      }
    }
  }

  /**
   * 반품 승인처리 Modal cancel handler
   */
  const handleReceiveModalCancel = () => {
    setReceiveModalOpen(false)
    setTrackNumber({
      deliveryCompany: null,
      trackingNumber: '',
      shipmentPlace: '',
      collectionDate:
        dayjs().add(3, 'days').day() === 0
          ? dayjs().add(4, 'days')
          : dayjs().add(3, 'days'),
    })
  }

  /**
   * 반품 승인처리 Modal > 선택된 주문 정보 테이블 row click
   */
  const handleSelectedOrderRowEvent = (record) => {
    return {
      onClick: () => {
        setTrackNumber({
          ...trackNumber,
          shipmentPlace: record.shipmentPlace,
        })
        setIsEditForShipmentPlace(false)
      },
    }
  }

  /**
   * 반품 거부(철회) 처리 Modal cancel handler
   */
  const handleReturnRefusalModalCancel = () => {
    setReturnRefusalModalOpen(false)
    setRefusalReason(null)
  }

  /**
   * 반품 송장 입력 Modal click handler
   */
  const handleRegisterTrackingClick = () => {
    setIsTrackNumberShow(true)
    for (let i = 0; i < selectedRow?.length; i++) {
      const row = selectedRow[i]
      if (row.returnTrackingNumber && !trackNumber.trackingNumber) {
        setTrackNumber({
          trackingNumber: row.returnTrackingNumber,
          deliveryCompany: row.returnDeliveryCompany,
        })
        break
      }
    }
  }

  /**
   * 반품 송장 입력 Modal cancel handler
   */
  const handleRegisterTrackingModalCancel = () => {
    setIsTrackNumberShow(false)
    setTrackNumber({
      deliveryCompany: null,
      trackingNumber: '',
    })
  }

  /**
   * 반품비용 설정 Modal click handler
   */
  const handleReturnCostSettingClick = async () => {
    await getOrderDetailListInfoForReturn()
    setCostSettingModalOpen(true)
  }

  /**
   * 반품비용 설정 Modal cancel handler
   */
  const handleReturnCostSettingModalCancel = () => {
    setCostSettingModalOpen(false)
    setCostInfo({
      possibleAmount: 0,
      additionalCost: 0,
      reason: null,
    })
  }

  /**
   * 반품완료 > 환불안내 Modal cancel handler
   */
  const handleReturnCompleteModalCancel = () => {
    setReturnCompleteModalOpen(false)
    setRefundInfo({
      calHistory: '',
      total: 0,
    })
  }

  /**
   * 반품 승인처리 버튼 밸리데이션 - 반품요청, 반품거부
   * @returns {boolean}
   */
  const disabledReturnRequest = () => {
    if (selectedRow?.length === 0) {
      return true
    } else {
      return !selectedRow.every(
        (row) => row.orderDetailStatus === 'return_request',
      )
    }
  }

  /**
   * 반품 거부처리 버튼 밸리데이션 - 반품 완료 처리가 불가능한 건 (반품 불가상품 또는 파손된 경우)
   * + 동일한 주문번호만 선택할 수 있도록 처리 (반품완료/반품거부(철회) 제외) (2023.07.11) - ksb
   * @returns {boolean}
   */
  const disabledReturnRefusal = () => {
    if (selectedRow?.length === 0) {
      return true
    } else {
      let orderId = 0
      let validList = []
      for (let i = 0; i < selectedRow?.length; i++) {
        const row = selectedRow[i]
        if (i === 0) {
          orderId = row.orderId
          if (
            row.orderDetailStatus === 'return_complete' ||
            row.orderDetailStatus === 'return_refusal'
          ) {
            validList.push(false)
          } else {
            validList.push(true)
          }
        } else {
          if (row.orderId !== orderId) {
            validList.push(false)
          } else {
            if (
              row.orderDetailStatus === 'return_complete' ||
              row.orderDetailStatus === 'return_refusal'
            ) {
              validList.push(false)
            } else {
              validList.push(true)
            }
          }
        }
      }
      return !validList.every((result) => result)
    }
  }

  /**
   * 반품 송장 입력 버튼 밸리데이션 - 반품승인/반품수거완료/반품수거취소/반품배송중 및 동일한 주문번호만 허용
   * @returns {boolean}
   */
  const disabledReturnReceive = () => {
    if (selectedRow?.length === 0) {
      return true
    } else {
      let orderId = 0
      let validList = []
      for (let i = 0; i < selectedRow?.length; i++) {
        const row = selectedRow[i]
        if (i === 0) {
          orderId = row.orderId
          if (
            row.orderDetailStatus === 'return_receive' ||
            row.orderDetailStatus === 'return_collection_complete' ||
            row.orderDetailStatus === 'return_delivery' ||
            row.orderDetailStatus === 'return_collection_fail'
          ) {
            validList.push(true)
          } else {
            validList.push(false)
          }
        } else {
          if (row.orderId !== orderId) {
            validList.push(false)
          } else {
            if (
              row.orderDetailStatus === 'return_receive' ||
              row.orderDetailStatus === 'return_collection_complete' ||
              row.orderDetailStatus === 'return_delivery' ||
              row.orderDetailStatus === 'return_collection_fail'
            ) {
              validList.push(true)
            } else {
              validList.push(false)
            }
          }
        }
      }
      return !validList.every((result) => result)
    }
  }

  /**
   * 반품 입고 완료 버튼 밸리데이션 - 반품승인/반품수거완료/반품수거취소/반품배송중만 허용
   * @returns {boolean}
   */
  const disabledReturnCollection = () => {
    if (selectedRow?.length === 0) {
      return true
    } else {
      return !selectedRow.every(
        (row) =>
          row.orderDetailStatus === 'return_receive' ||
          row.orderDetailStatus === 'return_collection_complete' ||
          row.orderDetailStatus === 'return_collection_fail' ||
          row.orderDetailStatus === 'return_delivery',
      )
    }
  }

  /**
   * 반품 완료처리 버튼 밸리데이션 - 동일한 주문번호에 대해 반품배송완료만 허용
   * @returns {boolean}
   */
  const disabledReturnComplete = () => {
    if (selectedRow?.length === 0) {
      return true
    } else {
      let orderId = 0
      let validList = []
      for (let i = 0; i < selectedRow?.length; i++) {
        const row = selectedRow[i]
        if (i === 0) {
          orderId = row.orderId
          if (row.orderDetailStatus === 'return_delivery_complete') {
            validList.push(true)
          } else {
            validList.push(false)
          }
        } else {
          if (
            row.orderId === orderId &&
            row.orderDetailStatus === 'return_delivery_complete'
          ) {
            validList.push(true)
          } else {
            validList.push(false)
          }
        }
      }
      return !validList.every((result) => result)
    }
  }

  /**
   * 반품 비용 설정 버튼 밸리데이션 - 반품배송완료인 하나의 주문만 허용
   * @returns {boolean}
   */
  const disabledReturnCostSetting = () => {
    return (
      selectedRow?.length === 1 &&
      selectedRow[0].orderDetailStatus === 'return_delivery_complete'
    )
  }

  const disabledAdminCancelComplete2 = () => {
    if (selectedRow?.length === 0) {
      return true
    } else {
      let orderId = 0
      let validList = []
      for (let i = 0; i < selectedRow?.length; i++) {
        const row = selectedRow[i]
        if (i === 0) {
          orderId = row.orderId
          if (row.hasOwnProperty('isDeposit') && row.isDeposit) {
            validList.push(true)
          } else {
            if (row.orderDetailStatus === 'paid') {
              validList.push(true)
            } else {
              validList.push(false)
            }
          }
        } else {
          if (row.orderId !== orderId) {
            validList.push(false)
          } else {
            if (row.hasOwnProperty('isDeposit') && row.isDeposit) {
              validList.push(true)
            } else {
              if (row.orderDetailStatus === 'paid') {
                validList.push(true)
              } else {
                validList.push(false)
              }
            }
          }
        }
      }
      return !validList.every((result) => result)
    }
  }

  const checkVbankInfo = () => {
    const refundBankCode = selectedRow[0]?.refundBank
    const refundBankName = Object.keys(kginicisBankCode).find(
      (key) => kginicisBankCode[key] === refundBankCode,
    )

    Swal.fire({
      title: `${selectedRow[0]?.createdByName} (userId : ${selectedRow[0]?.updatedBy})님의 무통장 입금(가상 계좌) 환불 정보입니다.
        계좌 정보에 오류가 있을 경우 개발팀에 꼭 공유해주세요!
        
        예금주 성명: ${selectedRow[0]?.refundHolder}
        계좌번호 : ${selectedRow[0]?.refundAccount}
        환불 은행 : ${refundBankName}
        환불 은행 코드 : ${selectedRow[0]?.refundBank}
        `,

      customClass: 'custom-alert',
      // confirmButtonColor: isBestResult ? '#ff4d4f' : '#117ffa',
      confirmButtonText: '확인',
      showCancelButton: true,
      cancelButtonText: '취소',
    })
  }

  const kginicisBankCode = {
    KB국민: '04',
    SC제일: '23',
    경남은행: '39',
    광주: '34',
    IBK기업: '03',
    NH농협: '11',
    'iM뱅크(대구)': '31',
    부산: '32',
    산업은행: '02',
    새마을금고: '45',
    수협: '07',
    신한: '88',
    신협: '48',
    외환은행: '81',
    우리: '20',
    우체국: '71',
    전북: '37',
    축협: '12',
    카카오뱅크: '90',
    케이뱅크: '89',
    하나: '81',
    한국씨티은행: '27',
    토스뱅크: '92',
  }
  useEffect(() => {
    if (propsType) {
      getUserOrderList()
    }
  }, [orderType, orderBy])

  /**
   * 반품 거부 알림톡 보내기
   */
  const sendKakaoRefusalAlert = async (orderParam) => {
    try {
      const res = await pushApi.kakaoForRefundRequestRefusal(
        orderParam,
        user.id,
      )
      // console.log('sendKakaoAlert', res)
      if (res.data.code !== 200) {
        alert(
          '선택한 주문들에 대해 카카오알림톡을 보내는데 실패하였습니다.\n관리자에게 문의해주시길 바랍니다.',
        )
        return res
      } else {
        // console.log('sendKakaoAlert success', res.data.result)
        return res
      }
    } catch (error) {
      setIsLoading(false)
      console.log('sendKakaoAlert alert error', error)
      throw error
    }
  }

  /**
   * 프로그램 환불 처리
   */
  const unavailableProgram = async (userOrderId) => {
    try {
      const res = await programApi.refundProgram(userOrderId)
      console.log('unavailableProgram', res)
    } catch (error) {
      console.log('unavailableProgram error', error)
    }
  }

  return (
    <>
      <ContentHeader title="반품관리" />
      <div className={`${styles['product-register-wrap']}`}>
        {/* 반품 상태값 조회 */}
        <Row
          justify="space-around"
          className={`${styles['product-search-product-status-wrap']} ${styles['return-wrap']}`}
        >
          {/* 수거요청실패 부터 4개 */}
          <div className={`${styles['product-return-wrap']}`}>
            <Row
              className={`${styles['product-status-box-wrap']} ${
                searchValue.searchText &&
                searchValue.searchText === 'return_collection_fail'
                  ? styles['product-status-active']
                  : ''
              }`}
              onClick={() =>
                handleReturnStatusItemClick(
                  'return_collection_fail',
                  returnStatus.returnCollectionFail,
                )
              }
              onMouseEnter={() => setCollectionFailHover(true)}
              onMouseLeave={() => setCollectionFailHover(false)}
              style={{ width: '25%' }}
            >
              <img
                className={`${styles['product-status-icon']}`}
                src={`${process.env.REACT_APP_HOST}/assets/icon/product/return${
                  (searchValue.searchText &&
                    searchValue.searchText === 'return_collection_fail') ||
                  collectionFailHover
                    ? 'B'
                    : ''
                }-4.png`}
                alt={`수거요청실패`}
              />
              <div className={`${styles['product-status-text']}`}>
                <div>수거요청실패</div>
                <div>
                  <span
                    className={`${styles['product-status-num']}`}
                    style={{ color: '#fe2b4b', fontWeight: 'bold' }}
                  >
                    {returnStatus.returnCollectionFail
                      ? returnStatus.returnCollectionFail?.length
                      : 0}
                  </span>{' '}
                  건
                </div>
              </div>
            </Row>
            <Row
              className={`${styles['product-status-box-wrap']} ${
                searchValue.searchText &&
                searchValue.searchText === 'return_delay'
                  ? styles['product-status-active']
                  : ''
              }`}
              onClick={() =>
                handleReturnStatusItemClick(
                  'return_delay',
                  returnStatus.returnDelay,
                )
              }
              onMouseEnter={() => setReturnDelayHover(true)}
              onMouseLeave={() => setReturnDelayHover(false)}
              style={{ width: '25%' }}
            >
              <img
                className={`${styles['product-status-icon']}`}
                src={`${process.env.REACT_APP_HOST}/assets/icon/product/return${
                  (searchValue.searchText &&
                    searchValue.searchText === 'return_delay') ||
                  returnDelayHover
                    ? 'B'
                    : ''
                }-5.png`}
                alt={`반품지연`}
              />
              <div className={`${styles['product-status-text']}`}>
                <div>반품지연</div>
                <div>
                  <span
                    className={`${styles['product-status-num']}`}
                    style={{ color: '#fe2b4b', fontWeight: 'bold' }}
                  >
                    {returnStatus.returnDelay
                      ? returnStatus.returnDelay?.length
                      : 0}
                  </span>{' '}
                  건
                </div>
              </div>
            </Row>

            <Row
              className={`${styles['product-status-box-wrap']} ${
                searchValue.searchText &&
                searchValue.searchText === 'return_refund_delay'
                  ? styles['product-status-active']
                  : ''
              }`}
              onClick={() =>
                handleReturnStatusItemClick(
                  'return_refund_delay',
                  returnStatus.returnRefundDelay,
                )
              }
              onMouseEnter={() => setRefundDelayHover(true)}
              onMouseLeave={() => setRefundDelayHover(false)}
              style={{ width: '25%' }}
            >
              <img
                className={`${styles['product-status-icon']}`}
                src={`${process.env.REACT_APP_HOST}/assets/icon/product/return${
                  (searchValue.searchText &&
                    searchValue.searchText === 'return_refund_delay') ||
                  refundDelayHover
                    ? 'B'
                    : ''
                }-6.png`}
                alt={`환불지연`}
              />
              <div className={`${styles['product-status-text']}`}>
                <div>환불지연</div>
                <div>
                  <span
                    className={`${styles['product-status-num']}`}
                    style={{ color: '#fe2b4b', fontWeight: 'bold' }}
                  >
                    {returnStatus.returnRefundDelay
                      ? returnStatus.returnRefundDelay?.length
                      : 0}
                  </span>{' '}
                  건
                </div>
              </div>
            </Row>

            {/*빈 공간을 위한 상태 아이템*/}
            <Row
              className={`${styles['product-status-box-wrap']}`}
              style={{
                visibility: 'hidden',
                width: '25%',
              }}
            >
              <img
                className={`${styles['product-status-icon']}`}
                src={`${process.env.REACT_APP_HOST}/assets/icon/product/return-6.png`}
                alt={`환불지연`}
              />
              <div className={`${styles['product-status-text']}`}>
                <div>환불지연</div>
                <div>
                  <span
                    className={`${styles['product-status-num']}`}
                    style={{ color: '#fe2b4b', fontWeight: 'bold' }}
                  >
                    {returnStatus.returnRefundDelay
                      ? returnStatus.returnRefundDelay?.length
                      : 0}
                  </span>{' '}
                  건
                </div>
              </div>
            </Row>
          </div>
          {/*반품요청 부터 4개*/}
          <div className={`${styles['product-return-wrap']}`}>
            {/* 반품 요청 부터 4개 표기 */}
            <Row
              className={`${styles['product-status-box-wrap']} ${
                searchValue.searchText &&
                searchValue.searchText === 'return_request'
                  ? styles['product-status-active']
                  : ''
              }`}
              onClick={() =>
                handleReturnStatusItemClick(
                  'return_request',
                  returnStatus.returnRequest,
                )
              }
              onMouseEnter={() => setReturnRequestHover(true)}
              onMouseLeave={() => setReturnRequestHover(false)}
              style={{ width: '25%' }}
            >
              <img
                className={`${styles['product-status-icon']}`}
                src={`${process.env.REACT_APP_HOST}/assets/icon/product/return${
                  (searchValue.searchText &&
                    searchValue.searchText === 'return_request') ||
                  returnRequestHover
                    ? 'B'
                    : ''
                }-0.png`}
                alt={`반품요청`}
              />
              <div className={`${styles['product-status-text']}`}>
                <div>반품요청</div>
                <div>
                  <span className={`${styles['product-status-num']}`}>
                    {returnStatus.returnRequest
                      ? returnStatus.returnRequest?.length
                      : 0}
                  </span>{' '}
                  건
                </div>
              </div>
            </Row>

            <Row
              className={`${styles['product-status-box-wrap']} ${
                searchValue.searchText &&
                searchValue.searchText === 'return_delivery'
                  ? styles['product-status-active']
                  : ''
              }`}
              onClick={() =>
                handleReturnStatusItemClick(
                  'return_delivery',
                  returnStatus.returnDelivery,
                )
              }
              onMouseEnter={() => setReturnDeliveryHover(true)}
              onMouseLeave={() => setReturnDeliveryHover(false)}
              style={{ width: '25%' }}
            >
              <img
                className={`${styles['product-status-icon']}`}
                src={`${process.env.REACT_APP_HOST}/assets/icon/product/return${
                  (searchValue.searchText &&
                    searchValue.searchText === 'return_delivery') ||
                  returnDeliveryHover
                    ? 'B'
                    : ''
                }-1.png`}
                alt={`반품배송중`}
              />
              <div className={`${styles['product-status-text']}`}>
                <div>반품배송중</div>
                <div>
                  <span className={`${styles['product-status-num']}`}>
                    {returnStatus.returnDelivery
                      ? returnStatus.returnDelivery?.length
                      : 0}
                  </span>{' '}
                  건
                </div>
              </div>
            </Row>

            <Row
              className={`${styles['product-status-box-wrap']} ${
                searchValue.searchText &&
                searchValue.searchText === 'return_delivery_complete'
                  ? styles['product-status-active']
                  : ''
              }`}
              onClick={() =>
                handleReturnStatusItemClick(
                  'return_delivery_complete',
                  returnStatus.returnDeliveryComplete,
                )
              }
              onMouseEnter={() => setReturnDeliveryCompleteHover(true)}
              onMouseLeave={() => setReturnDeliveryCompleteHover(false)}
              style={{ width: '25%' }}
            >
              <img
                className={`${styles['product-status-icon']}`}
                src={`${process.env.REACT_APP_HOST}/assets/icon/product/return${
                  (searchValue.searchText &&
                    searchValue.searchText === 'return_delivery_complete') ||
                  returnDeliveryCompleteHover
                    ? 'B'
                    : ''
                }-2.png`}
                alt={`반품배송완료`}
              />
              <div className={`${styles['product-status-text']}`}>
                <div>반품배송완료</div>
                <div>
                  <span className={`${styles['product-status-num']}`}>
                    {returnStatus.returnDeliveryComplete
                      ? returnStatus.returnDeliveryComplete?.length
                      : 0}
                  </span>{' '}
                  건
                </div>
              </div>
            </Row>

            <Row
              className={`${styles['product-status-box-wrap']} ${
                searchValue.searchText &&
                searchValue.searchText === 'return_complete'
                  ? styles['product-status-active']
                  : ''
              }`}
              onClick={() =>
                handleReturnStatusItemClick(
                  'return_complete',
                  returnStatus.returnComplete,
                )
              }
              onMouseEnter={() => setReturnCompleteHover(true)}
              onMouseLeave={() => setReturnCompleteHover(false)}
              style={{ width: '25%' }}
            >
              <img
                className={`${styles['product-status-icon']}`}
                src={`${process.env.REACT_APP_HOST}/assets/icon/product/return${
                  (searchValue.searchText &&
                    searchValue.searchText === 'return_complete') ||
                  returnCompleteHover
                    ? 'B'
                    : ''
                }-3.png`}
                alt={'반품완료(최근 3일)'}
              />
              <div className={`${styles['product-status-text']}`}>
                <div>반품완료(최근 3일)</div>
                <div>
                  <span className={`${styles['product-status-num']}`}>
                    {returnStatus.returnComplete
                      ? returnStatus.returnComplete?.length
                      : 0}
                  </span>{' '}
                  건
                </div>
              </div>
            </Row>
          </div>
        </Row>

        {/*주문검색*/}
        <div className={`${styles['product-search-box-wrap']}`}>
          <Form.Item
            label="조회기간"
            labelAlign="left"
            colon={false}
            labelCol={{ span: 3 }}
            wrapperCol={{ span: 21 }}
          >
            <Select
              value={searchOptions.searchType}
              onChange={(value) =>
                setSearchOptions({ ...searchOptions, searchType: value })
              }
              style={{ width: 250, textAlign: 'left' }}
            >
              {searchDateItems.map((item, idx) => (
                <Select.Option
                  key={`order_date_search_${idx}`}
                  value={item.searchType}
                >
                  {item.searchText}
                </Select.Option>
              ))}
            </Select>
            <ConfigProvider theme={CustomDateButtonRadioTheme}>
              <Row align={'middle'} style={{ marginTop: 10, gap: '5px' }}>
                <Radio.Group
                  className={`${styles['options-list']}`}
                  options={dateTypeItems}
                  onChange={handleDateTypeChange}
                  value={dateType}
                  optionType="button"
                />
                <DatePicker
                  className={`${styles['order-search-date-wrap']}`}
                  format="YYYY/MM/DD"
                  value={
                    searchOptions.startDate
                      ? dayjs(searchOptions.startDate)
                      : null
                  } // dayjs로 변환
                  onChange={(value) => {
                    setDateType('')
                    setSearchOptions({
                      ...searchOptions,
                      startDate: dayjs(value),
                    }) // dayjs로 변환하여 저장
                  }}
                />
                ~
                <DatePicker
                  className={`${styles['order-search-date-wrap']}`}
                  format="YYYY/MM/DD"
                  value={
                    searchOptions.endDate ? dayjs(searchOptions.endDate) : null
                  } // dayjs로 변환
                  onChange={(value) => {
                    setDateType('')
                    setSearchOptions({
                      ...searchOptions,
                      endDate: dayjs(value),
                    }) // dayjs로 변환하여 저장
                  }}
                />
              </Row>
            </ConfigProvider>
          </Form.Item>
          <Divider
            className={`${styles['product-register-form-input-divider']}`}
          />
          <Form.Item
            className={`${styles['center-label']}`}
            label="처리상태"
            labelAlign="left"
            colon={false}
            labelCol={{ span: 3 }}
            wrapperCol={{ span: 21 }}
          >
            <Select
              value={searchOptions.searchStatus}
              onChange={(value) =>
                setSearchOptions({ ...searchOptions, searchStatus: value })
              }
              style={{ width: 250, textAlign: 'left' }}
            >
              {orderStatusItems.map((item, idx) => (
                <Select.Option
                  key={`order_status_search_${idx}`}
                  value={item.value}
                >
                  {item.label}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>
          <Divider
            className={`${styles['product-register-form-input-divider']}`}
          />
          <Form.Item
            label="상세검색"
            labelAlign="left"
            colon={false}
            labelCol={{ span: 3 }}
            wrapperCol={{ span: 21 }}
          >
            <Row align="middle">
              <Col sm={5} md={2}>
                <div className={`${styles['content-search-wrap']}`}>
                  주문번호
                </div>
              </Col>
              <Col style={{ marginRight: '2rem' }}>
                <Input
                  name="searchOrderId"
                  value={searchOptions.searchOrderId}
                  onChange={(e) => {
                    const reg = /^[0-9]*$/
                    if (reg.test(e.target.value) || e.target.value === '') {
                      setSearchOptions({
                        ...searchOptions,
                        [e.target.name]: e.target.value,
                      })
                    }
                  }}
                  style={{ width: 150, textAlign: 'left' }}
                  onPressEnter={handleSearch}
                />
              </Col>
              <Col sm={5} md={2}>
                <div className={`${styles['content-search-wrap']}`}>상품명</div>
              </Col>
              <Col style={{ marginRight: '2rem' }}>
                <Input
                  name="searchProductName"
                  value={searchOptions.searchProductName}
                  onChange={(e) =>
                    setSearchOptions({
                      ...searchOptions,
                      [e.target.name]: e.target.value,
                    })
                  }
                  style={{ width: 150, textAlign: 'left' }}
                  onPressEnter={handleSearch}
                />
              </Col>
            </Row>
            <Row align="middle" style={{ marginTop: 10 }}>
              <Col sm={5} md={2}>
                <div className={`${styles['content-search-wrap']}`}>이름</div>
              </Col>
              <Col style={{ marginRight: '2rem' }}>
                <Input
                  name="name"
                  value={searchOptions.name}
                  onChange={(e) =>
                    setSearchOptions({
                      ...searchOptions,
                      [e.target.name]: e.target.value,
                    })
                  }
                  style={{ width: 150, textAlign: 'left' }}
                  onPressEnter={handleSearch}
                />
              </Col>
              <Col sm={5} md={2}>
                <div className={`${styles['content-search-wrap']}`}>연락처</div>
              </Col>
              <Col>
                <Input
                  name="phone"
                  value={searchOptions.phone}
                  onChange={(e) =>
                    setSearchOptions({
                      ...searchOptions,
                      [e.target.name]: e.target.value,
                    })
                  }
                  style={{ width: 150, textAlign: 'left' }}
                  onPressEnter={handleSearch}
                />
              </Col>
            </Row>
          </Form.Item>
          <Divider
            className={`${styles['product-register-form-input-divider']}`}
          />
          <Row
            className={`${styles['product-search-button-wrap']}`}
            justify="center"
          >
            <Button
              className={`${styles['product-search-button']} ${styles.search}`}
              onClick={handleSearch}
            >
              검색
            </Button>
            <Button
              className={`${styles['product-search-button']} ${styles.initial}`}
              onClick={handleInitialBtnClick}
            >
              초기화
            </Button>
          </Row>
        </div>

        {/*주문검색목록*/}
        <Row
          className={`${styles['product-register-border-box']}`}
          justify={'space-between'}
          wrap={false}
          style={{ marginTop: 20, borderBottom: 0 }}
        >
          <div>
            <span className={`${styles['product-register-box-title']}`}>
              상품목록 (총{' '}
              <span
                className={`${styles['product-register-box-subtitle']}`}
                style={{ marginLeft: 0 }}
              >
                {totalSize}
              </span>
              개)
            </span>
            <span className={`${styles['product-list-subtitle']}`}>
              {orderPair[orderType]}
            </span>
          </div>
          <div>
            <Button
              className={`${styles['order-excel-download-btn']}`}
              icon={
                <img
                  style={{ height: 14.2, width: 14.5 }}
                  src={`${process.env.REACT_APP_HOST}/assets/icon/common/microsoftexcel.png`}
                />
              }
              onClick={handleExcelDownloadClick}
            >
              엑셀다운
            </Button>
          </div>
        </Row>
        <Row
          className={`${styles['product-register-border-box']}`}
          justify={'space-between'}
          wrap={false}
        >
          <Row align={'middle'} style={{ gap: 10 }}>
            <Button
              className={`${styles['order-status-change-button']}`}
              disabled={disabledReturnRequest()}
              loading={isLoading}
              onClick={handleReceiveModalClick}
            >
              반품 승인처리
            </Button>
            <Button
              className={`${styles['order-status-change-button']}`}
              disabled={disabledReturnRefusal()}
              onClick={() => setReturnRefusalModalOpen(true)}
            >
              반품 거부처리
            </Button>
            <Button
              className={`${styles['order-status-change-button']}`}
              disabled={disabledAdminCancelComplete2()}
              onClick={() => checkVbankInfo()}
              style={
                !disabledAdminCancelComplete2()
                  ? {
                      color: 'red',
                      fontWeight: 'bold',
                      borderColor: 'red',
                    }
                  : {}
              }
            >
              [주의] 무통장 입금건 취소 계좌 정보
            </Button>
          </Row>
          <div>
            <Button
              className={`${styles['order-excel-download-btn']}`}
              onClick={() => setShowWarningModal(true)}
            >
              주의
            </Button>
          </div>
        </Row>
        <div
          className={`${styles['product-register-border-box']}`}
          style={{
            borderTop: 0,
            padding: '20px 25px 40px',
            height: 'fit-content',
          }}
        >
          <Table
            rowSelection={rowSelection}
            columns={columns}
            dataSource={orderList}
            loading={isLoading}
            tableLayout={'auto'}
            bordered
            size="middle"
            rowKey="orderDetailId"
            rowClassName="coupon-table-row"
            // scroll={{x: 'calc(700px + 50%)'}}
            scroll={{ x: 'max-content' }}
            onChange={tableOnChange}
            pagination={false}
          />

          <Pagination
            showSizeChanger
            pageSize={pageSize}
            onShowSizeChange={pageSizeChange}
            total={totalSize}
            current={currentPageNumber}
            onChange={handleChangePagination}
            align={'end'}
            style={{ marginTop: 20 }}
          />
        </div>
        <div
          className={`${styles['product-register-border-box']}`}
          style={{
            backgroundColor: '#f8f9fd',
            height: 'fit-content',
            padding: '15px 25px',
            borderTop: 0,
          }}
        >
          <Form.Item
            className={`${styles['order-bottom-form-item']} ${styles['center-label']}`}
            label="반품처리"
            labelAlign="left"
            colon={false}
            labelCol={{ span: 3 }}
            wrapperCol={{ span: 21 }}
          >
            <Row align={'middle'} style={{ gap: 10 }}>
              <Button
                className={`${styles['order-status-change-button']}`}
                disabled={disabledReturnReceive()}
                loading={isLoading}
                onClick={handleRegisterTrackingClick}
              >
                반품 송장 입력
              </Button>

              <Button
                className={`${styles['order-status-change-button']}`}
                disabled={disabledReturnCollection()}
                loading={isLoading}
                onClick={() => changeOrderStatus('return_delivery_complete')}
              >
                입고 완료
              </Button>
              <Button
                className={`${styles['order-status-change-button']}`}
                disabled={disabledReturnComplete()}
                loading={isLoading}
                onClick={handleReturnCompleteClick}
              >
                반품 완료처리
              </Button>
            </Row>
          </Form.Item>
          {user && user.role && user.role === 'super_admin' && (
            <>
              <Divider
                className={`${styles['product-register-form-input-divider']} ${styles['order-bottom-divider-margin']}`}
              />
              <Form.Item
                className={`${styles['order-bottom-form-item']} ${styles['center-label']}`}
                label="환불처리"
                labelAlign="left"
                colon={false}
                labelCol={{ span: 3 }}
                wrapperCol={{ span: 21 }}
              >
                <Row>
                  <Button
                    className={`${styles['order-status-change-button']}`}
                    disabled={disabledReturnCostSetting()}
                    loading={isLoading}
                    onClick={handleReturnCostSettingClick}
                  >
                    반품비용 설정
                  </Button>
                </Row>
              </Form.Item>
            </>
          )}
        </div>

        {/*반품 승인시 회수택배사/수거예정일/수거지 입력*/}
        <Modal
          title="반품 승인 처리"
          open={receiveModalOpen}
          onCancel={handleReceiveModalCancel}
          onOk={returnReceive}
          okText={<span>저장</span>}
          okButtonProps={{
            disabled: !(
              trackNumber.deliveryCompany &&
              trackNumber.collectionDate &&
              trackNumber.shipmentPlace?.trim()
            ),
          }}
          centered={true}
          confirmLoading={isLoading}
          width={'50%'}
        >
          <p style={{ marginBottom: 0 }}>
            • 구매자분께 안내드릴 수거 택배사 및 수거 예정일을 입력해주세요.
          </p>
          <p style={{ marginBottom: 0 }}>
            • 수거지는 각 상품별 판매자정보에 등록된 반품/교환 회수지입니다.
            직접 수정하시면 선택된 주문 목록 전체에 적용됩니다.
          </p>
          <p style={{ marginBottom: 0 }}>
            • 반품 승인 시 프로그램의 경우 즉시 이용 불가 처리됩니다.
          </p>
          <p style={{ marginBottom: 0 }}>
            • 더 원활한 처리를 위해 주문건 단위로 요청 부탁드립니다.
          </p>
          <Row className="select-order-info-title">
            <div className="deco-box"></div>
            선택된 주문 정보
          </Row>
          <Table
            columns={columnsForRefusal}
            dataSource={selectedRow}
            // loading={isLoading}
            tableLayout={'auto'}
            bordered
            size="middle"
            rowKey="orderDetailId"
            rowClassName="coupon-table-row"
            onRow={handleSelectedOrderRowEvent}
            scroll={{ x: 'max-content', y: 145 }}
            pagination={false}
          />
          <Form.Item
            className="register-tracking-number-form"
            label="택배사"
            labelAlign="left"
            colon={false}
            labelCol={{ span: 6 }}
            wrapperCol={{ span: 18 }}
          >
            <Select
              placeholder="택배사를 선택헤주세요"
              value={trackNumber.deliveryCompany}
              onChange={(value) =>
                setTrackNumber({
                  ...trackNumber,
                  deliveryCompany: value,
                })
              }
              style={{ width: 250, textAlign: 'left' }}
            >
              {deliveryCompanyList.map((item, idx) => (
                <Select.Option
                  key={`delivery_company_${idx}`}
                  value={item.deliveryCompanyId}
                >
                  {item.deliveryCompanyName}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>
          <Form.Item
            className="register-tracking-number-form"
            label="수거 예정일"
            labelAlign="left"
            colon={false}
            labelCol={{ span: 6 }}
            wrapperCol={{ span: 18 }}
          >
            <DatePicker
              className="order-search-date-wrap"
              format="YYYY/MM/DD"
              allowClear={false}
              disabledDate={(current) =>
                current < dayjs().endOf('day') || current.day() === 0
              }
              value={trackNumber.collectionDate}
              onChange={(value) => {
                setTrackNumber({ ...trackNumber, collectionDate: value })
              }}
            />
          </Form.Item>
          <Form.Item
            className="register-tracking-number-form"
            label="수거지"
            labelAlign="left"
            colon={false}
            labelCol={{ span: 6 }}
            wrapperCol={{ span: 18 }}
          >
            <Input
              value={trackNumber.shipmentPlace}
              onChange={(e) => {
                setIsEditForShipmentPlace(true)
                setTrackNumber({
                  ...trackNumber,
                  shipmentPlace: e.target.value,
                })
              }}
            />
          </Form.Item>
        </Modal>

        {/*반품 거부 사유 입력*/}
        <Modal
          title="반품 거부(철회) 처리"
          open={returnRefusalModalOpen}
          onCancel={handleReturnRefusalModalCancel}
          onOk={returnRefusal}
          okText={<span>저장</span>}
          okButtonProps={{ disabled: !refusalReason?.trim() }}
          centered={true}
          confirmLoading={isLoading}
          width={'50%'}
        >
          <p style={{ marginBottom: 0 }}>
            • 구매자에게 반품불가 사유를 사전에 안내하시고 반품 거부처리 진행해
            주세요.
          </p>
          <p style={{ marginBottom: 0 }}>
            • 입력하신 반품거부 사유는{' '}
            <strong style={{ color: 'red' }}>
              카카오톡 혹은 문자로 구매자에게 그대로 안내
            </strong>
            되니 반드시 유의하여 작성해주세요.
          </p>
          <Row className="select-order-info-title">
            <div className="deco-box"></div>
            선택된 주문 정보
          </Row>
          <Table
            // rowSelection={rowSelection}
            columns={columnsForRefusal}
            dataSource={selectedRow}
            // loading={isLoading}
            tableLayout={'auto'}
            bordered
            size="middle"
            rowKey="orderDetailId"
            // rowClassName="coupon-table-row"
            scroll={{ x: 'max-content', y: 145 }}
            pagination={false}
          />
          <Form.Item
            className="refusal-text-form"
            label="반품 거부 사유"
            labelAlign="left"
            colon={false}
            labelCol={{ span: 6 }}
            wrapperCol={{ span: 18 }}
            required
          >
            <Input.TextArea
              name="refusalReason"
              value={refusalReason}
              onChange={(e) => setRefusalReason(e.target.value)}
              placeholder=" 슈가코치에서 요청하신 반품 건이 아래 사유로 접수되지 않았어요. 반려 사유를 확인해주시고, 궁금한 점 있으시면 언제든지 저희 고객센터로 편하게 문의해주세요."
            />
          </Form.Item>
        </Modal>

        {/* 반품 송장 입력 */}
        <Modal
          title="반품 송장 입력"
          open={isTrackNumberShow}
          onCancel={handleRegisterTrackingModalCancel}
          onOk={handleTrackNumber}
          okText={<span>저장</span>}
          okButtonProps={{
            disabled: !(
              trackNumber.trackingNumber?.trim() && trackNumber.deliveryCompany
            ),
          }}
          confirmLoading={isLoading}
          centered={true}
          width={'50%'}
        >
          <Row className="select-order-info-title" style={{ marginTop: 0 }}>
            <div className="deco-box"></div>
            선택된 주문 정보
          </Row>
          <Table
            // rowSelection={rowSelection}
            columns={columnsForRefusal}
            dataSource={selectedRow}
            // loading={isLoading}
            tableLayout={'auto'}
            bordered
            size="middle"
            rowKey="orderDetailId"
            // rowClassName="coupon-table-row"
            scroll={{ x: 'max-content', y: 145 }}
            pagination={false}
          />
          <Form.Item
            className="register-tracking-number-form"
            label="택배사"
            labelAlign="left"
            colon={false}
            labelCol={{ span: 6 }}
            wrapperCol={{ span: 18 }}
          >
            <Select
              placeholder="택배사를 선택해주세요"
              value={trackNumber.deliveryCompany}
              onChange={(value) =>
                setTrackNumber({
                  ...trackNumber,
                  deliveryCompany: value,
                })
              }
              style={{ width: 250, textAlign: 'left' }}
            >
              {deliveryCompanyList.map((item, idx) => (
                <Select.Option
                  key={`deliveryCompany_${idx}`}
                  value={item.deliveryCompanyId}
                >
                  {item.deliveryCompanyName}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>
          <Form.Item
            label="송장번호"
            labelAlign="left"
            colon={false}
            labelCol={{ span: 6 }}
            wrapperCol={{ span: 18 }}
          >
            <Input
              className="order-modal-address-request-wrap"
              name="trackNumber"
              value={trackNumber.trackingNumber}
              onChange={(e) =>
                setTrackNumber({
                  ...trackNumber,
                  trackingNumber: e.target.value,
                })
              }
            />
          </Form.Item>
        </Modal>

        {/*반품비용 설정*/}
        <Modal
          title="반품비용 설정"
          open={costSettingModalOpen}
          onCancel={handleReturnCostSettingModalCancel}
          onOk={registerEtcReturnPrice}
          okText={<span>저장</span>}
          okButtonProps={{
            disabled: !(
              costInfo.reason?.trim() && costInfo.additional_cost !== null
            ),
          }}
          confirmLoading={isLoading}
          centered={true}
          width={'50%'}
        >
          <p style={{ marginBottom: 0 }}>
            • 상품 파손 등의 이유로 반품배송비 이외의 금액을 제외하고 환불해야할
            경우에 작성해주세요.
          </p>
          <p style={{ marginBottom: 0 }}>
            • 선택된 주문번호로 결제된 금액 및 상품별 설정된 반품비용을 제외한
            금액 내에서 설정가능합니다.
          </p>
          <p style={{ marginBottom: 0 }}>
            • 작성된 사유가 고객분께 그대로 안내가 될 예정이니 신중하게
            작성해주십시오.
          </p>
          <p>
            • 수거 물품이 정상인지 불량인지 꼭 확인 후 입고 완료를 눌러주세요.
            이후에는 반품 비용이 변경할 수 없습니다.
          </p>
          <p style={{ marginBottom: 0 }}>
            • 예시) 추가 반품비용 금액 : 6000원을 입력할 경우 총 지불 금액에서
            6000원이 차감되어 환불됩니다.
          </p>
          <Row className="select-order-info-title">
            <div className="deco-box"></div>
            선택된 주문 정보
          </Row>
          <Table
            // rowSelection={rowSelection}
            columns={columnsForRefusal}
            dataSource={selectedRow}
            // loading={isLoading}
            tableLayout={'auto'}
            bordered
            size="middle"
            rowKey="orderDetailId"
            // rowClassName="coupon-table-row"
            scroll={{ x: 'max-content', y: 145 }}
            pagination={false}
          />
          <Form.Item
            className="return-additional-cost-input-form refusal-text-form"
            label="추가 반품비용 금액"
            labelAlign="left"
            colon={false}
            labelCol={{ span: 6 }}
            wrapperCol={{ span: 18 }}
          >
            <Row align="middle">
              <InputNumber
                formatter={(value) =>
                  value.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
                }
                parser={(value) => value.replace(/\$\s?|(,*)/g, '')}
                min={0}
                max={costInfo.possibleAmount}
                addonAfter="원"
                disabled={!costInfo?.possibleAmount}
                value={costInfo.additionalCost}
                onChange={(value) =>
                  setCostInfo({ ...costInfo, additionalCost: value })
                }
              />
              <p
                style={{
                  marginLeft: '1rem',
                  marginBottom: 0,
                  color: '#fe2b4b',
                }}
              >
                *{' '}
                {costInfo.possibleAmount
                  ? costInfo.possibleAmount.toLocaleString() + '원 이하'
                  : '입력할 수 없음'}
              </p>
            </Row>
          </Form.Item>
          <Form.Item
            className="refusal-text-form"
            label="사유"
            labelAlign="left"
            colon={false}
            labelCol={{ span: 6 }}
            wrapperCol={{ span: 18 }}
          >
            <Input.TextArea
              name="reason"
              value={costInfo.reason}
              onChange={(e) =>
                setCostInfo({ ...costInfo, reason: e.target.value })
              }
            />
          </Form.Item>
        </Modal>

        {/*환불 안내*/}
        {returnCompleteModalOpen && (
          <Modal
            title="환불 안내"
            wrapClassName="return-complete-modal-wrap"
            open={returnCompleteModalOpen}
            closable={false}
            onCancel={handleReturnCompleteModalCancel}
            onOk={registerReturnComplete}
            okText={<span>확인</span>}
            confirmLoading={isLoading}
            centered={true}
            width={'50%'}
          >
            <Form.Item
              className="return-complete-form-border-box"
              label="주문번호"
              labelAlign="left"
              colon={false}
              labelCol={{ span: 4 }}
              wrapperCol={{ span: 20 }}
            >
              {selectedRow[0].orderId}
            </Form.Item>
            <Row align="middle" wrap={false}>
              <Col span={12}>
                <Form.Item
                  className="return-complete-form-border-box"
                  label="수취인명"
                  labelAlign="left"
                  colon={false}
                  labelCol={{ span: 8 }}
                  wrapperCol={{ span: 16 }}
                  style={{ borderRight: 0 }}
                >
                  {selectedRow[0].name}
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item
                  className="return-complete-form-border-box"
                  label="구매자명"
                  labelAlign="left"
                  colon={false}
                  labelCol={{ span: 8 }}
                  wrapperCol={{ span: 16 }}
                >
                  {selectedRow[0].createdByName
                    ? selectedRow[0].createdByName
                    : selectedRow[0].name}
                </Form.Item>
              </Col>
            </Row>
            <Form.Item
              className="return-complete-form-border-box"
              label="상품명"
              labelAlign="left"
              colon={false}
              labelCol={{ span: 4 }}
              wrapperCol={{ span: 20 }}
            >
              {`[${selectedRow[0].brandName}] ${selectedRow[0].productName}${
                selectedRow[0].optionId
                  ? ` - ${selectedRow[0].optionTitle}`
                  : ''
              }${
                selectedRow?.length > 1
                  ? ` 외 ${selectedRow?.length - 1}건`
                  : ''
              }`}
            </Form.Item>
            <Form.Item
              className="return-complete-form-border-box"
              label="결제금액"
              labelAlign="left"
              colon={false}
              labelCol={{ span: 4 }}
              wrapperCol={{ span: 20 }}
            >
              {`${selectedRow[0].paymentTotalPrice.toLocaleString()}원`}
            </Form.Item>
            <Row align="middle" wrap={false}>
              <Col span={12}>
                <Form.Item
                  className="return-complete-form-border-box"
                  label="반품 배송비"
                  labelAlign="left"
                  colon={false}
                  labelCol={{ span: 8 }}
                  wrapperCol={{ span: 16 }}
                  style={{ borderRight: 0 }}
                >
                  {selectedRow[0].returnResponsibility === 'USER'
                    ? `${(
                        selectedRow[0].returnDeliveryPrice -
                        selectedRow[0].paidTotalDeliveryPrice
                      )?.toLocaleString()}원`
                    : '0원'}
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item
                  className="return-complete-form-border-box"
                  label="결제정보"
                  labelAlign="left"
                  colon={false}
                  labelCol={{ span: 8 }}
                  wrapperCol={{ span: 16 }}
                >
                  {selectedRow[0].returnResponsibility === 'USER'
                    ? selectedRow[0].purchaseReturnPrice
                      ? '선불'
                      : '환불금에서 차감'
                    : '판매자 부담'}
                </Form.Item>
              </Col>
            </Row>
            {selectedRow.map((row) => {
              if (row.etcReturnPrice) {
                return (
                  <>
                    <Form.Item
                      className="return-complete-form-border-box"
                      label="추가 반품비"
                      labelAlign="left"
                      colon={false}
                      labelCol={{ span: 4 }}
                      wrapperCol={{ span: 20 }}
                    >
                      {`${row.etcReturnPrice.toLocaleString()}원`}
                    </Form.Item>
                    <Form.Item
                      className="return-complete-form-border-box"
                      label="사유"
                      labelAlign="left"
                      colon={false}
                      labelCol={{ span: 4 }}
                      wrapperCol={{ span: 20 }}
                    >
                      {row.etcReturnPriceReason}
                    </Form.Item>
                  </>
                )
              }
            })}
            <Form.Item
              className="return-complete-form-border-box"
              label="총 환불 금액"
              labelAlign="left"
              colon={false}
              labelCol={{ span: 4 }}
              wrapperCol={{ span: 20 }}
              style={{ borderBottom: 'solid 1px #ced4da' }}
            >
              <p style={{ marginBottom: 0 }}>{refundInfo.calHistory}</p>
              <p className="return-complete-refund-amount">{`${refundInfo.total.toLocaleString()}원`}</p>
            </Form.Item>
          </Modal>
        )}

        {/*주문 상세 페이지*/}
        {isOrderModalOpen && (
          <Modal
            title="상품주문정보 조회"
            wrapClassName="order-detail-modal-wrap"
            open={isOrderModalOpen}
            centered={true}
            onCancel={handleOrderDetailModalCancel}
            footer={null}
            width="70%"
          >
            <OrderDetailComponent
              orderDetail={orderDetail}
              handleOrderDetailModalCancel={handleOrderDetailModalCancel}
              getUserOrderList={getUserOrderList}
            />
          </Modal>
        )}

        {/*반품 주의 사항 모달 ui 개선하기*/}
        {showWarningModal && (
          <Modal
            title="반품 주의사항"
            wrapClassName="order-detail-modal-wrap"
            open={showWarningModal}
            centered={true}
            onCancel={() => setShowWarningModal(false)}
            footer={null}
            width={'50%'}
            style={{ height: '50vh', overflowY: 'auto' }}
          >
            <div>
              <strong>반품 주의 사항</strong>
              <p>슈가몰은 자동 반품 수거 시스템이 아닙니다.</p>
              <p>반품 배송비 여부를 반드시 확인하셔야 합니다.</p>
              <br></br>
              <strong>반품 승인</strong>
              <p>
                반품 승인시 굿스플로우에서 반품 수거를 요청하고, 하단 반품
                처리를 순서대로 완료해주십시오.
              </p>
              <br></br>
              <strong>반품 거부</strong>
              <p>
                반품 거부시 반품 배송비를 지불하였을 경우 반품 배송비 또한
                환불되어야 하므로 관리자에게 요청해주십시오. (상세 내역에서
                반드시 반품 배송비 여부를 확인해주십시오.)
              </p>
              <br></br>
              <strong>반품 비용 설정</strong>
              <p>
                반품 배송비를 결제하지 않았으나 고객님의 과실이 있었을 경우 혹은
                상품 파손 등 다양한 이유로 환불 금액이 다를 시 사용하는
                버튼입니다.
              </p>
              <p>
                수거 물품이 정상인지 불량인지 꼭 확인 후 입고 완료를 눌러주세요.
                이후에는 반품 비용이 변경할 수 없습니다.
              </p>
              <p>
                예시) 추가 반품비용 금액 : 6000원을 입력할 경우 총 지불 금액에서
                6000원이 차감되어 환불됩니다
              </p>
            </div>
          </Modal>
        )}
      </div>
    </>
  )
}

export default OrderReturnPage
